import React from 'react';
import { Sparkles as LucideSparkles } from 'lucide-react';

interface SparklesProps {
  width?: number;
  height?: number;
  className?: string;
  style?: React.CSSProperties;
}

const Sparkles: React.FC<SparklesProps> = ({ width = 24, height = 24, className, style }) => (
  <LucideSparkles width={width} height={height} className={className} style={style} aria-hidden strokeWidth={2} />
);

export default Sparkles;
